import Axios from 'axios';

import { GET_ALL_USER } from 'constants/URLs';
import { GET_ACCOUNT_USERS } from 'lib/opentelemetry/constants/spansNames';
import { buildAxiosConfig } from '../config';

/**
 * Sends the request that fetches all users of the current account (PK_User, Username, PK_Account…).
 *
 * Pure request: builds the config and performs the call, returning the raw response so callers can
 * wrap it with `retry`. The account users live at `response.data.Users`.
 *
 * @returns {Promise<Object>} Raw Axios response.
 */
export const apiGetAccountUsers = () => {
    return Axios.get(GET_ALL_USER(), buildAxiosConfig(GET_ACCOUNT_USERS));
};
